/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

const FONT_FAMILY = 'Open Sans, Regular, sans-serif';
const WHITE = '#FFFFFF';
const LIGHT_GRAY = '#c7c7c7';

const HeaderStyles = {
  modalHeader: {
    alignItems: 'center',
    backgroundColor: WHITE,
    minHeight: '64px',
    boxShadow: `0 1px 0 0 ${LIGHT_GRAY}`,
    padding: '0 18px',
    zIndex: '101',
    display: 'inline-block'
  },
  title: {
    color: '#636769',
    textAlign: 'center',
    fontSize: '18px',
    height: 'auto',
    lineHeight: 'auto',
    padding: '5px 0 5px 0',
    whiteSpace: 'normal',
    borderBottom: 'none',
    wordWrap: 'break-word',
    fontFamily: FONT_FAMILY,
    margin: '0 auto',
    fontWeight: 500
  },
  closeBtn: {
    marginRight: '12px',
    width: '36px',
    height: '36px',
    zIndex: 1
  },
  headerCloseBtn: {
    marginRight: '-16px',
    marginTop: '8px',
    width: 36,
    height: 36,
    zIndex: 1
  },
  toolBar: {
    width: '100%',
    padding: 0
  }
};

export default HeaderStyles;



// WEBPACK FOOTER //
// ./src/js/components/Header/HeaderStyles.jsx